<template>
  <span :style="cssVars">
    {{ timeLeft | countdownFormat }}
  </span>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    seconds: {
      type: Number,
      required: false,
      default: 300,
    },
    color: {
      type: String,
      required: false,
      default: 'auto',
    },
    hideSeconds: { // todo
      type: Boolean,
      required: false,
      default: false,
    },
    callback: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      timeLeft: null,
      timeInterval: null,
    };
  },
  computed: {
    cssVars() {
      return {
        '--color': this.color,
      };
    },
    individualClockItems() {
      return this.$options.filters.playerTimeFormat(this.timeLeft).toString().split('');
    },
  },
  mounted() {
    this.timeLeft = this.seconds;
    this.timeInterval = setInterval(this.countdown, 1000);
  },
  methods: {
    countdown() {
      this.timeLeft--;
      // console.log(this.$options.filters.playerTimeFormat(this.timeLeft).toString().split('')); // TODO: idea for displaying all kinds of timers without shrinking/expanding depending on font. This way we could print every individual character with fixed width
      if (this.timeLeft <= 0) {
        this.timeLeft = 0;
        clearInterval(this.timeInterval);
        this.callback();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  span {
    color: var(--color);
    line-height: 1.2;
  }
</style>
